import '@ori/icons';
import '@ori/online-modal/build/style.css';
import { default as bemCssModules } from 'bem-css-modules';
import { config } from './helpers/config';
import { ErrorBoundary } from './containers/ErrorBoundary/ErrorBoundary';
import { i18n } from './helpers/i18n';
import { I18nextProvider } from 'react-i18next';
import { NotifyPopup } from './components/NotifyPopup/NotifyPopup';
import { translationKeys } from './helpers/translationKeys';
import React, { Suspense } from 'react';
bemCssModules.setSettings({
    modifierDelimiter: '--',
    throwOnError: true,
});
export const App = () => (React.createElement(ErrorBoundary, null,
    React.createElement(Suspense, { fallback: null },
        React.createElement(I18nextProvider, { i18n: i18n(`${config.baseURL}/system/ajax/Localization/Translate`, translationKeys()) },
            React.createElement(NotifyPopup, null)))));
